/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileEmailIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Email',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 2v10h10L20 2z" />
    <path d="M16 23a1 1 0 011-1h13v-8H19a1 1 0 01-1-1V2H7a1 1 0 00-1 1v30a1 1 0 001 1h9z" />
    <path
      d="M28.208 32.25L36 26.584V35a1 1 0 01-1 1H19a1 1 0 01-1-1v-8.416l7.792 5.667a2.054 2.054 0 002.416-.001zM27 30.347L36 24H18z"
    />
  </svg>`;
};
